import { useQuery } from "@apollo/client";
import { QUERY_HOME_SCREEN } from "utility/graphQl/query";
import { logError } from "utility/Function";
import appInfo from "utility/app-info";
import {
  LearnerScreens,
  AssessmentSchedule,
  LearnerIndexScores,
} from "../api/types";

const useFetchHomeData = () => {
  const {
    data,
    loading,
    error,
    refetch: refetchHome,
  } = useQuery<{
    learner: {
      screens: Pick<LearnerScreens, "home" | "index">;
      indexScores?: LearnerIndexScores;
      assessmentSchedule?: AssessmentSchedule;
    };
  }>(QUERY_HOME_SCREEN, {
    fetchPolicy: "cache-and-network",
    onError(error) {
      logError("Error while fetching home screen data", error);
    },
    variables: {
      appInfo,
    },
  });

  return {
    data,
    loading,
    error,
    refetchHome,
  };
};

export default useFetchHomeData;
